import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CancellationIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "cancellationGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.5444 22C7.03024 22 2.54443 17.5147 2.54443 12.0005C2.54443 6.4863 7.03024 2 12.5444 2C14.5149 2 16.4216 2.5728 18.0581 3.65564C18.2896 3.80864 18.3529 4.12055 18.1999 4.35202C18.0459 4.58154 17.735 4.64725 17.504 4.49326C16.0323 3.51929 14.3173 3.00436 12.5444 3.00436C7.58441 3.00436 3.5488 7.03948 3.5488 11.9995C3.5488 16.9595 7.58441 20.9956 12.5444 20.9956C17.5045 20.9956 21.5401 16.9605 21.5401 12.0005C21.5401 10.8264 21.3174 9.68477 20.879 8.60683C20.774 8.34986 20.8976 8.05659 21.1546 7.95262C21.4106 7.84767 21.7048 7.97028 21.8088 8.22823C22.2968 9.4268 22.5444 10.695 22.5444 11.9995C22.5444 17.5137 18.0586 22 12.5444 22Z"
        fill={fill}
      />
      <path
        d="M12.2703 14.1328C12.1457 14.1328 12.0212 14.0867 11.9245 13.9945L8.47597 10.7176C8.2749 10.5263 8.26656 10.2085 8.45782 10.0075C8.64859 9.80638 8.96688 9.79952 9.16745 9.98979L12.2678 12.9352L21.6936 3.84199C21.8942 3.64974 22.2114 3.65367 22.4037 3.85474C22.5964 4.05385 22.5905 4.37164 22.3909 4.56387L12.619 13.9916C12.5219 14.0857 12.3958 14.1328 12.2703 14.1328Z"
        fill={fill}
      />
    </svg>
  );
};

export default CancellationIcon;
